import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EndpointService } from './endpoint.service';
import nameOf from 'src/app/shared/form/nameOf.helper';
import {
  SampleCollectionMetricsRequest,
  SampleCollectionMetricsResponse
} from '../models/dashboard/sample-collection-metrics.model';

@Injectable({ providedIn: 'root' })
export class SampleWidgetService extends EndpointService {
  constructor(http: HttpClient) {
    super(http);
  }

  getCollectionMetrics(request: SampleCollectionMetricsRequest): Observable<SampleCollectionMetricsResponse> {
    let params = new HttpParams()
      .set(nameOf<SampleCollectionMetricsRequest>(x => x.timeRange), request.timeRange)
      .set(nameOf<SampleCollectionMetricsRequest>(x => x.granularity), request.granularity)
      .set(nameOf<SampleCollectionMetricsRequest>(x => x.stackBy), request.stackBy);

    if (request.organizationLevelId != null) {
      params = params.set(nameOf<SampleCollectionMetricsRequest>(x => x.organizationLevelId), request.organizationLevelId);
    }
    if (request.agentGroupId != null) {
      params = params.set(nameOf<SampleCollectionMetricsRequest>(x => x.agentGroupId), request.agentGroupId);
    }
    if (request.agentIds?.length) {
      request.agentIds.forEach(id => params = params.append(nameOf<SampleCollectionMetricsRequest>(x => x.agentIds), id));
    }
    if (request.segIds?.length) {
      request.segIds.forEach(id => params = params.append(nameOf<SampleCollectionMetricsRequest>(x => x.segIds), id));
    }
    if (request.surveyTypeIds?.length) {
      request.surveyTypeIds.forEach(id => params = params.append(nameOf<SampleCollectionMetricsRequest>(x => x.surveyTypeIds), id));
    }
    if (request.customStartDate != null) {
      params = params.set(nameOf<SampleCollectionMetricsRequest>(x => x.customStartDate), request.customStartDate);
    }
    if (request.customEndDate != null) {
      params = params.set(nameOf<SampleCollectionMetricsRequest>(x => x.customEndDate), request.customEndDate);
    }
    if (request.shiftType != null) {
      params = params.set(nameOf<SampleCollectionMetricsRequest>(x => x.shiftType), request.shiftType);
    }

    return this.http.get<SampleCollectionMetricsResponse>(
      this.getApiUrl('Sample/GetSampleCollectionMetrics'),
      { params }
    );
  }
}
